export const constructStrRep = (obj) => {
  return obj.premises_id || "Gemensam yta";
};
export const detailUrl = ({ id }) => {
  return `/common-areas/detail/${id}`;
};
export const overviewUrl = () => {
  return "/common-areas";
};
